import AICloudDeveloperPage from "./AICloudDeveloperPage";

export default function AwsDeveloperPage() {
  return <AICloudDeveloperPage technology="aws" />;
}
